import axios from 'axios';
import { API_BASE_URL } from '../../../../lib/constants';

export const fetchPatientData = async (uhidNo) => {
  const response = await axios.get(`${API_BASE_URL}/get_patient/${uhidNo}`);
  return response.data;
};

export const fetchAnalgesiaAssessment = async (uhidNo) => {
  const response = await axios.get(`${API_BASE_URL}/get_assessment/${uhidNo}`);
  return response.data;
};

export const fetchNextIpNo = async () => {
  const response = await axios.get(`${API_BASE_URL}/assessment_next_ip`);
  return response.data;
};

export const submitAnalgesiaAssessment = async (data) => {
  const response = await axios.post(`${API_BASE_URL}/submit_assessment`, data);
  return response.data;
};

export const updateAnalgesiaAssessment = async (id, data) => {
  const response = await axios.put(`${API_BASE_URL}/update_assessment/${id}`, data);
  return response.data;
};

export const generateShareToken = async (uhidNo) => {
  const response = await axios.post(`${API_BASE_URL}/generate_share_token/${uhidNo}`);
  return response.data;
};
